import React from 'react';
import ModelViewer from 'src/components/modelViewer/modelViewer';
import ModelViewerLayout from 'src/components/modelViewer/modelViewer-layout';


const ModelViewerPage: React.FC = () => {
  return (
    <ModelViewerLayout children={<ModelViewer/>}></ModelViewerLayout>
  );
};

export default ModelViewerPage;